export default __webpack_public_path__ + "static/media/baseline-menu-24px.cd58549a.svg";